import React, { useState } from 'react';
import './faq.css';
import { useNavigate } from 'react-router-dom';
import { CLIENT_SUPPORT_HUB_PATH } from './supportHubPaths';

const FAQ = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [expandedSections, setExpandedSections] = useState({});

  const faqSections = [
    {
      title: "Getting Started",
      questions: [
        {
          q: "What is a Master Account?",
          a: "The master account is designed for you to view and manage all of your locations, talent, talent requests, and messaging schedules. It cannot be used as one of your locations to listen to music. Therefore the 'Channels' page is not active within your master account."
        },
        {
          q: "How do I access my account?",
          a: "You can access your account by signing in at KrossKast.com with your master account credentials."
        },
        {
          q: "What browsers are supported?",
          a: "We recommend using Google Chrome for the best experience. Other modern browsers like Firefox and Safari are also supported."
        }
      ]
    },
    {
      title: "Music Streaming",
      questions: [
        {
          q: "How do I listen to music on mobile devices?",
          a: `Free KrossKast App for Mobile, Tablet, and Chrome Devices:
              1. Navigate to the Locations page located on the side bar to access your login credentials. Use your PIN to access passwords.
              2. With the device you will be streaming on, search for "KrossKast" in the Google Play Store or Apple App Store.
              3. Download and open our app. Enter your location's username and password found on the Locations page.
              4. Click Sign In and select a music channel to start streaming unlimited music.`,
          hasVideoLink: true
        },
        {
          q: "How do I listen to music on desktop?",
          a: `Free Web App for Desktop and Laptop:
              1. Navigate to the Locations page located on the side bar to access your login credentials. Use your PIN to access passwords.
              2. On the desktop or laptop that you'll be streaming from, open the Chrome Web Browser.
              3. Go to KrossKast.com and sign in. Enter your location's username and password found on the Locations page.
              4. Click Sign In and navigate to the Channels page to start streaming unlimited music.`,
          hasVideoLink: true
        }
      ]
    },
    {
      title: "Account Management",
      questions: [
        {
          q: "How do I add a new location?",
          a: "You can add a new location from the Locations page in your master account. Click the '+ Add Location' button and follow the setup process."
        },
        {
          q: "Lost your PIN?",
          a: "If you lost your PIN please go to the Support page and contact us to reset your PIN (additional verification will be required)."
        }
      ]
    },
    {
      title: "Billing & Subscription",
      questions: [
        {
          q: "How does billing work?",
          a: "Billing is handled on a per-location basis. Each location has its own subscription that can be managed from the Billing page."
        },
        {
          q: "What payment methods do you accept?",
          a: "We accept all major credit cards and ACH bank transfers for business accounts."
        }
      ]
    }
  ];

  // Filter function to search through all FAQ content
  const getFilteredSections = () => {
    if (!searchQuery.trim()) return faqSections;

    const query = searchQuery.toLowerCase();
    return faqSections.map(section => ({
      ...section,
      questions: section.questions.filter(item => 
        item.q.toLowerCase().includes(query) || 
        item.a.toLowerCase().includes(query)
      )
    })).filter(section => section.questions.length > 0);
  };

  const toggleSection = (sectionId) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionId]: !prev[sectionId]
    }));
  };

  return (
    <>
      <h1>FAQ</h1>
      <div className="faq-content">
        <div className="search-container">
          <input
            type="text"
            placeholder="Search FAQs..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search-input"
          />
          {searchQuery && (
            <button 
              className="clear-search"
              onClick={() => setSearchQuery('')}
            >
              ✕
            </button>
          )}
        </div>

        {getFilteredSections().map((section, index) => (
          <div key={index} className="faq-section">
            <div 
              className="section-header"
              onClick={() => toggleSection(index)}
            >
              <h2>{section.title}</h2>
              <button className="toggle-btn">
                {expandedSections[index] ? '−' : '+'}
              </button>
            </div>
            {expandedSections[index] && (
              <div className="questions-list">
                {section.questions.map((item, qIndex) => (
                  <div key={qIndex} className="faq-item">
                    <h3>{item.q}</h3>
                    <p className="faq-answer">{item.a}</p>
                    {item.hasVideoLink && (
                      <a href="#" className="video-link">Video Tutorial</a>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
        
        {getFilteredSections().length === 0 && (
          <div className="no-results">
            No results found for "{searchQuery}"
          </div>
        )}
        
        <div className="faq-footer">
          <p>Still have questions? Visit our <span className="link" onClick={() => navigate(CLIENT_SUPPORT_HUB_PATH)}>Support page</span> for additional help.</p>
        </div>
      </div>
    </>
  );
};

export default FAQ; 